export default __webpack_public_path__ + "static/media/gourmet-area.a4748d0e.png";